(() => {
  const root = document.querySelector('.fp-brand-v1');
  if (!root) return;
  const cards = [...root.querySelectorAll('[data-brand-product]')];
  let species = 'all', family = null;
  let activeParams = cleanParams(new URLSearchParams(window.location.search));
  const money = cents => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);
  let cartItems = [];
  function cleanParams(params) {
    const result = new URLSearchParams();
    params.forEach((value, key) => {
      if (key !== 'sort_by' && key !== 'page') result.append(key, value);
    });
    return result;
  }
  function paramsForCurrentSelection() {
    const params = new URLSearchParams();
    if (species !== 'all') params.set('fp_species', species);
    if (family) params.set('fp_family', family);
    return params;
  }
  function syncSortForm() {
    const form = root.querySelector('[data-brand-sort-form]');
    const sort = root.querySelector('[data-brand-sort]');
    if (!form || !sort) return;
    form.querySelectorAll('[data-brand-preserved-param], [data-brand-dynamic-param]').forEach(input => input.remove());
    activeParams.forEach((value, key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      input.setAttribute('data-brand-dynamic-param', '');
      form.insertBefore(input, sort);
    });
  }
  function replaceUrl() {
    const query = activeParams.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ''}#productos`;
    window.history.replaceState({}, '', url);
  }
  function updateCard(form) {
    const id = form.querySelector('input[name=id]:checked')?.value || form.querySelector('input[name=id]').value;
    const quantity = cartItems.filter(item => String(item.variant_id) === id).reduce((sum, item) => sum + item.quantity, 0);
    form.closest('[data-brand-product]').classList.toggle('is-in-cart', quantity > 0);
    form.querySelector('.fp-brand-card__add-label').textContent = quantity ? `✓ ${quantity}` : '+ Agregar';
    form.querySelector('.fp-brand-card__add-icon').textContent = quantity ? `✓ ${quantity}` : '+';
  }
  async function refreshCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    cartItems = cart.items || [];
    root.querySelector('[data-cart-title]').textContent = `${cart.item_count} ${cart.item_count === 1 ? 'producto FridaPets' : 'productos FridaPets'} · ${money(cart.total_price)}`;
    root.querySelector('[data-brand-cart]').hidden = cart.item_count === 0;
    root.querySelectorAll('[data-brand-add]').forEach(updateCard);
  }
  function filter() {
    const compatible = cards.filter(card => species === 'all' || card.dataset.species.split(' ').includes(species));
    let count = 0;
    cards.forEach(card => {
      card.hidden = !compatible.includes(card) || (family && card.dataset.family !== family);
      if (!card.hidden) count++;
    });
    root.querySelector('[data-brand-count]').textContent = count;
    root.querySelector('[data-brand-empty]').hidden = count > 0;
    root.querySelector('[data-brand-clear]').hidden = species === 'all' && !family;
    root.querySelectorAll('[data-brand-line]').forEach(line => {
      const total = compatible.filter(card => card.dataset.family === line.dataset.brandLine).length;
      line.hidden = total === 0;
      line.querySelector('[data-line-count]').textContent = `${total} ${total === 1 ? 'producto' : 'productos'}`;
      if (family === line.dataset.brandLine) line.setAttribute('aria-current', 'true');
      else line.removeAttribute('aria-current');
    });
    syncSortForm();
  }
  function hydrateStateFromUrl() {
    const requestedSpecies = activeParams.get('fp_species');
    const requestedFamily = activeParams.get('fp_family');
    if (requestedSpecies && root.querySelector(`[data-brand-species="${requestedSpecies}"]`)) species = requestedSpecies;
    if (requestedFamily && root.querySelector(`[data-brand-line="${requestedFamily}"]`)) family = requestedFamily;
    root.querySelectorAll('[data-brand-species]').forEach(a => a.dataset.brandSpecies === species ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current'));
  }
  root.querySelectorAll('[data-brand-species]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    species = link.dataset.brandSpecies;
    family = null;
    activeParams = paramsForCurrentSelection();
    replaceUrl();
    root.querySelectorAll('[data-brand-species]').forEach(a => a === link ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current'));
    filter();
  }));
  root.querySelectorAll('[data-brand-line]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    family = family === link.dataset.brandLine ? null : link.dataset.brandLine;
    activeParams = paramsForCurrentSelection();
    replaceUrl();
    filter();
  }));
  root.querySelector('[data-brand-clear]').addEventListener('click', event => {
    event.preventDefault();
    species = 'all';
    family = null;
    activeParams = new URLSearchParams();
    replaceUrl();
    root.querySelectorAll('[data-brand-species]').forEach(a => a.dataset.brandSpecies === 'all' ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current'));
    filter();
  });
  hydrateStateFromUrl();
  filter();
  root.querySelector('[data-brand-sort]').addEventListener('change', () => {
    syncSortForm();
    root.querySelector('[data-brand-sort-form]').requestSubmit();
  });
  root.querySelectorAll('[data-brand-add]').forEach(form => {
    form.addEventListener('change', () => {
      const selected = form.querySelector('input[name=id]:checked');
      if (selected) form.querySelector('[data-brand-price]').textContent = money(Number(selected.dataset.priceCents));
      updateCard(form);
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      const status = root.querySelector('[data-brand-status]');
      status.textContent = 'Agregando producto al carrito.';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'No pudimos agregar el producto. Revisa la presentación e inténtalo de nuevo.');
        status.textContent = 'Producto agregado al carrito.';
        await refreshCart();
      } catch (error) {
        // An uncertain response is not retried: the item may already be in the cart.
        status.textContent = 'No se pudo confirmar la actualización. Revisa tu carrito antes de intentarlo de nuevo.';
        root.querySelector('[data-cart-title]').textContent = 'Revisa tu carrito';
        root.querySelector('[data-brand-cart]').hidden = false;
      } finally { button.disabled = false; }
    });
  });
  refreshCart().catch(() => {});
  window.addEventListener('pageshow', event => {
    if (event.persisted) refreshCart().catch(() => {});
  });
})();
